import { React, useEffect, useState, forwardRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import * as api from 'services/api';
import { useControlCentreContext } from 'contexts/ControlCentreContext';
import { useTranslation } from 'react-i18next';

const InterventionTypeModal = forwardRef(
    
    function InterventionTypeModal({ state, show, setShow, onClose }, ref) {
        const { t } = useTranslation();
        const { controlCentre } = useControlCentreContext();
        const [newInterventionType, setNewInterventionType] = useState(0);
        const [interventionTypes, setInterventionTypes] = useState([]);

        //#region ------------------------------- STATES
        const [error, setError] = useState(null);
        const [success, setSuccess] = useState(null);
        const [disabledButt, setDisabledButt] = useState(false);
        //#endregion
        
        useEffect(() => {

            const fechActions = async () => {
                const actions = await api.getInterventionTypes();
                if (actions.status === 200) {
                    const enabledInterventionTypes = actions.data.filter(type => type.enable === true);
                    setInterventionTypes(enabledInterventionTypes);
                    setNewInterventionType(state.interventionType);

                } else {
                    console.error(t('errorObtainingActions'));
                }
            };

            if (state) {
                console.log(state);
                setNewInterventionType(state.interventionType || '');

                fechActions();

            }
        }, [state]);


        //#region ---------------------------- HANDLERS ----------------

        const handleSubmit = async (order) => {
            setError(null);
            setSuccess(null);
            
            try {
                let response = await api.updateControlCentreInterventionType(controlCentre.centreid, state.controlCentreConfigId, newInterventionType);
                console.log('update RESPONSE : ', response);
                if (response.status === 200 && response.data === true) {
                    setSuccess(t('ccPseudoCodeModified'));
                    setDisabledButt(true);
                    handleCloseModal();
                }
                if (response.data === false) {
                    setError(t('ccErrorSaveChanges'));
                }

            } catch (error) {
                console.log('SERVER ERROR...', error);
                setError(t('ccErrorSaveChanges'));
            }
        }

        const handleCloseModal = () => {
            setShow(false);
            setError(null);
            setSuccess(null);
            setDisabledButt(false);
            onClose();
        }

        const handleInterventionTypeChange = (event) => {
            const { value } = event.target;
            setNewInterventionType(value);
        }

        //#endregion
        return (
            <Modal show={show} onHide={handleCloseModal}
                ref={ref}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t('editInterventionType')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {interventionTypes.length > 1 && (<>
                            <div>
                                {t('numberInterventionType')}
                            </div>

                            <div className="flex-grow-1">
                                <Form.Select className="bg-light" onChange={handleInterventionTypeChange} value={newInterventionType}>
                                    <option key='_0' value='0'>
                                        {t('it.SelectInterventionType')}
                                    </option>
                                    {interventionTypes.map(interventionType => (
                                        <option key={interventionType.id} value={interventionType.id}>{t(`${interventionType.name}`)}</option>
                                     ))}
                                </Form.Select>
                            </div>
                        </>)}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='light' onClick={handleCloseModal}>{t('ccClose')}</Button>
                    <Button variant='primary' onClick={handleSubmit}>{t('ccSave')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
)


export default InterventionTypeModal;